import { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory, useLocation } from 'react-router';
import RouteUtils from '../modules/routeUtils';
import useIsMobile from './useIsMobile';

export default function useSearchFilters({ sendToSearchPage }) {
  const location = useLocation();
  const history = useHistory();
  const isMobile = useIsMobile(1080);

  const [searchFilters, setSearchFilters] = useState({});
  const [mapOpen, setMapOpen] = useState(false);

  // Keep refs to latest history/location to avoid recreating setFilters callback
  const historyRef = useRef(history);
  const locationRef = useRef(location);

  useEffect(() => {
    historyRef.current = history;
    locationRef.current = location;
  }, [history, location]);

  // Update search filters based on URL
  useEffect(() => {
    const params = RouteUtils.getQueryParams(location);
    // "Open now" became "Open today". Old links and bookmarks still carry
    // open_now=true, so read it as open_today. Whatever clears open_today
    // must clear open_now too, or the old flag brings the filter back.
    if (params.open_now) {
      params.open_today = params.open_today || params.open_now;
      delete params.open_now;
    }
    setSearchFilters(params);
  }, [location]);

  // Close map if switching to mobile
  useEffect(() => {
    if (isMobile) {
      setMapOpen(false);
    }
  }, [isMobile]);

  const setFilters = useCallback((params) => {
    if (sendToSearchPage) {
      RouteUtils.updateQueryParam(
        historyRef.current,
        locationRef.current,
        params,
        '/search'
      );
    } else {
      RouteUtils.updateQueryParam(
        historyRef.current,
        locationRef.current,
        params
      );
    }
  }, [sendToSearchPage]);

  return {
    searchFilters,
    setFilters,
    mapOpen,
    setMapOpen,
  };
}
